import {t} from "@lingui/macro";

export default () => [
    {
        required: true,
        message: t`The password is missing.`,
    },
    {
        min: 8,
        message: t`Minimum length for password is 8.`,
    },
    // {
    //   pattern: "(?=.*[A-Z])(?=.*[0-9])",
    //   message: "The password must have at least one upper case and 1 numeric character."
    // }
];
